__turbopack_context__.v({
  "author": "yjOipa_author",
  "avatar": "yjOipa_avatar",
  "desc": "yjOipa_desc",
  "disclaimer": "yjOipa_disclaimer",
  "heading": "yjOipa_heading",
  "location": "yjOipa_location",
  "shares-content": "yjOipa_shares-content",
  "testimonial": "yjOipa_testimonial",
  "testimonial-caption": "yjOipa_testimonial-caption",
  "testimonial-heading": "yjOipa_testimonial-heading",
  "testimonial-slide": "yjOipa_testimonial-slide",
});
